
const baseUrl = process.env.REACT_APP_BASE_URL || 'https://localhost:44333/api/';
const AuthApiService = {

  // Method for handling the signup API call
  signup: async (data) => {
    try {
      const apiEndpoint = `${baseUrl}Auth/signup`; // Complete URL for the signup endpoint

      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data), // Convert data to JSON
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message.errors[0].errorMessage || 'Error occurred');
      }

      const result = await response.json(); // Parse the JSON response
      return result; // Return response data on success
    } catch (error) {
      console.error('Signup error:', error);
      throw new Error(error);
    }
  },

  signin: async (data) => {
    try {
      const apiEndpoint = `${baseUrl}Auth/login`; // Complete URL for the signup endpoint

      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data), // Convert data to JSON
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error occurred');
      }

      const result = await response.json(); // Parse the JSON response
      return result; // Return response data on success
    } catch (error) {
      console.error('Signup error:', error);
      throw new Error('Network error');
    }
  },

  test: async (data) => {
    try {
      const apiEndpoint = `${baseUrl}Auth/test`; // Complete URL for the test endpoint

      const response = await fetch(apiEndpoint, {
        method: 'GET', // Correctly capitalized method
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error occurred');
      }

      const result = await response.json(); // Parse the JSON response
      return result; // Return response data on success
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

  login: async (data) => {
    try {
      const apiEndpoint = `${baseUrl}Auth/login`; // Complete URL for the signup endpoint

      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data), // Convert data to JSON
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error occurred');
      }

      const result = await response.json(); // Parse the JSON response
      return result; // Return response data on success
    } catch (error) {
      console.error('Signin error:', error);
      throw new Error('Network error');
    }
  },
  checkUserByEmail: async (data) => {
    try {
      const apiEndpoint = `${baseUrl}Auth/CheckUser`; // Complete URL for the signup endpoint

      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data), // Convert data to JSON
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error occurred');
      }

      const result = await response.json(); // Parse the JSON response


      return result; // Return response data on success
    } catch (error) {
      console.error('Signup error:', error);
      throw new Error('Network error');
    }
  },
  signInWithGoogle: async function (data) {
    try {
      const apiEndpoint = `${baseUrl}Auth/google-signin`;
      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data), // Convert data to JSON
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error occurred');
      }

      const result = await response.json(); // Parse the JSON response
      return result; // Return response data on success
    } catch (error) {
      console.error('Signup error:', error);
      throw new Error('Network error');
    }
  },
  RegisterUser: async function (remainingInfo) {
    try {
      const apiEndpoint = `${baseUrl}Auth/google-register`;
      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(remainingInfo), // Convert data to JSON
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error occurred');
      }

      return  await response.json(); // Parse the JSON response
    } catch (error) {
      console.error('Signup error:', error);
      throw new Error('Network error');
    }
  }
};

export default AuthApiService;
